import { ouponVoucherTypeLabels } from './enums'
import api from './api'
import { debounce } from 'vue-debounce';

export default {
    name: 'CouponVoucherIssueManager',
    props: {
        detailItem: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            isLoading: false,
            dialog: false,
            debounceFnc: null,
            detailItemSelected: null,
            form: {},
            items: [],
            search: '',
            pagination: {
                pageIndex: 1,
                pageSize: 20,
                orderBy: 'Id',
                DirectionSort: 'desc'
            },
            totalRows: 0
        }
    },
    mounted() {
        this.getIssueItems();
        this.debounceFnc = debounce(() => {
            this.pagination.pageIndex = 1
            this.getIssueItems();
        }, 500);
    },
    methods: {
        async getIssueItems() {
            this.isLoading = true
            const response = await api.getIssueItems(this.detailItem.id, { ...this.pagination, querySearch: this.search })
            const isSuceed = response.data.result === 0
            if (isSuceed) {
                this.items = response.data.data.items
                this.totalRows = response.data.data.totalRows
            }
            this.isLoading = false
        },
        refresh() {
            this.pagination.pageIndex = 1
            this.getIssueItems()
        },
        onPageChange(page) {
            this.pagination.pageIndex = page
            this.getIssueItems()
        },
        showDetail(item) {
            this.detailItemSelected = { ...item };
            this.dialog = true
        },
        acceptIssue(item) {
            this.$confirm('Accept this voucher. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(async () => {
                this.isLoading = true
                const response = await api.acceptIssue(item)
                const isSuceed = response.data.result === 0
                if (isSuceed) {                    
                    this.$message({
                        type: 'success',
                        message: 'Accept voucher completed'
                    });
                }
                item.isUsed = true;
                this.isLoading = false
                this.dialog = false;
                this.detailItemSelected = null;
                this.refresh();
            }).catch(() => { });
        },
        rejectIssue(item) {
            this.$confirm('Reject this voucher. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(async () => {
                this.isLoading = true
                const response = await api.rejectIssue(item)
                const isSuceed = response.data.result === 0
                if (isSuceed) {                    
                    this.$message({
                        type: 'success',
                        message: 'Reject voucher completed'
                    });
                }
                this.isLoading = false
                
                this.dialog = false;
                this.detailItemSelected = null;
                this.refresh();
                
            }).catch(() => { });
        }
    }
}
